import Box from "@mui/material/Box";
import Header from "../components/header/header";
import Footer from "../components/footer/footer";
import { ThemeProvider } from "@mui/material/styles";
// import { textStyle, theme } from "src/styles/textstyle";

import { useGetHomeQuery } from "src/redux/service/home.service";
import CircularProgress from "@mui/material/CircularProgress";
import { useParams } from "react-router-dom";
import NotFoundPage from "./MainPage/Components/NotFound";
import ContentBox, {
  InnerContentBox,
} from "src/components/ContentBox/ContentBox";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useState } from "react";
import { AccordionWrapper } from "./MainPage/Components/StillUnsure";
import TextField from "@mui/material/TextField";
import ApartmentIcon from "@mui/icons-material/Apartment";
import HomeIcon from "@mui/icons-material/Home";
import AvailabilitySelector from "src/components/availability/availability";
import { UserInfo } from "./UserPage/OwnUserPage";
import { User } from "src/model_types/user.types";
import ImagesModal from "src/components/modals/ImagesModal";
import theme from "src/styles/mainstyle";
import { useMediaQuery, useTheme } from "@mui/material";
import MainButton from "src/components/buttons/mainbutton";
import {
  useRequestContactMutation,
  useAcceptContactMutation,
} from "src/redux/service/users.service";
import { useSnackbar } from "notistack";
import { HomeWithUserData } from "src/model_types/home.types";
import { getIsSignedIn } from "src/redux/reducers/user";
import SignupModal from "src/components/modals/SignUpModal";
import { trackPostHogEvent } from "src/analytics/posthog";

const formatCamelCase = (str: string): string => {
  const capitalized = str.charAt(0).toUpperCase() + str.slice(1);
  const formatted = capitalized.replace(/([A-Z])/g, " $1").trim();
  return formatted.charAt(0).toUpperCase() + formatted.slice(1).toLowerCase();
};

export const tabStyle = {
  // textStyle,
  color: "inherit",
  "&.Mui-selected": {
    color: "black", // Chan
    backgroundColor: "inherit",
  },
};

export default function UserHome() {
  const { id } = useParams();
  const {
    data: home,
    isLoading: isLoadingHome,
    isError,
  } = useGetHomeQuery(id!);
  const [activeTab, setActiveTab] = useState(0);
  const mobileTheme = useTheme();
  const isDesktop = useMediaQuery(mobileTheme.breakpoints.down("sm"));

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const [open, setOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handleOpen = (index: number) => {
    setCurrentImageIndex(index);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handlePrev = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? (home?.files!.length || 0) - 1 : prevIndex - 1,
    );
  };

  const handleNext = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === (home?.files!.length || 0) - 1 ? 0 : prevIndex + 1,
    );
  };

  if (isLoadingHome) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }
  if (isError) {
    return <NotFoundPage redirectPath={`/homes/${id}`} />;
  }
  const description = Object.keys(home?.descriptions as any)
    .filter((value) => value !== "title")
    .map((value) => ({
      question: value,
      answer: home?.descriptions![value],
    }));

  return (
    <Box sx={{ pt: 5 }}>
      <ThemeProvider theme={theme}>
        <Header />
        <Grid container spacing={8} sx={{ pt: 8 }}>
          <Grid item xs={12} md={8} alignItems="flex-start">
            <ContentBox title={home?.descriptions?.title || ""}>
              <Grid container spacing={2}>
                {/* First image on the left */}
                <Grid item xs={12} md={6}>
                  {renderImageOrPlaceholder(
                    home?.files && home.files.length > 0
                      ? home.files[0]?.downloadUrl
                      : undefined,
                    0,
                    handleOpen,
                  )}
                </Grid>

                {/* Container for the second to fifth images */}
                <Grid item xs={12} md={6}>
                  <Grid container spacing={2}>
                    {/* Second image */}
                    <Grid item xs={6}>
                      {renderImageOrPlaceholder(
                        home?.files && home.files.length > 1
                          ? home.files[1]?.downloadUrl
                          : undefined,
                        1,
                        handleOpen,
                      )}
                    </Grid>
                    {/* Third image */}
                    <Grid item xs={6}>
                      {renderImageOrPlaceholder(
                        home?.files && home.files.length > 2
                          ? home.files[2]?.downloadUrl
                          : undefined,
                        2,
                        handleOpen,
                      )}
                    </Grid>
                    {/* Fourth image */}
                    <Grid item xs={6}>
                      {renderImageOrPlaceholder(
                        home?.files && home.files.length > 3
                          ? home.files[3]?.downloadUrl
                          : undefined,
                        3,
                        handleOpen,
                      )}
                    </Grid>
                    {/* Fifth image */}
                    <Grid item xs={6}>
                      {renderImageOrPlaceholder(
                        home?.files && home.files.length > 4
                          ? home.files[4]?.downloadUrl
                          : undefined,
                        4,
                        handleOpen,
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </ContentBox>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                paddingTop: 2,
              }}
            >
              <Box sx={{ width: "90%" }}>
                <Tabs
                  value={activeTab}
                  onChange={handleTabChange}
                  sx={{
                    borderBottom: 1,
                    borderColor: "divider",
                    width: "100%",
                    "& .MuiTabs-indicator": {
                      display: "none", // hide the sliding indicator
                    },
                  }}
                >
                  <Tab
                    label={
                      <Typography
                        variant="h4"
                        component="span"
                        sx={{
                          display: "inline-block",
                          lineHeight: 1,
                          fontWeight: 800,
                        }}
                      >
                        Descriptions
                      </Typography>
                    }
                    sx={{
                      ...tabStyle,
                      fontSize: { xs: "0.2rem", sm: "0.7rem" },
                      "&.Mui-selected": {
                        borderBottom: "3px solid black", // solid underline instead of sliding indicator
                      },
                    }}
                  />
                  <Tab
                    label={
                      <Typography
                        variant="h4"
                        component="span"
                        sx={{
                          display: "inline-block",
                          lineHeight: 1,
                          fontWeight: 800,
                        }}
                      >
                        Facilities
                      </Typography>
                    }
                    sx={{
                      ...tabStyle,
                      fontSize: { xs: "0.6rem", sm: "0.7rem" },
                      "&.Mui-selected": {
                        borderBottom: "3px solid black", // solid underline instead of sliding indicator
                      },
                    }}
                  />
                  <Tab
                    label={
                      <Typography
                        variant="h4"
                        component="span"
                        sx={{
                          display: "inline-block",
                          lineHeight: 1,
                          fontWeight: 800,
                        }}
                      >
                        Availability
                      </Typography>
                    }
                    sx={{
                      ...tabStyle,
                      fontSize: { xs: "0.6rem", sm: "0.7rem" },
                      "&.Mui-selected": {
                        borderBottom: "3px solid black", // solid underline instead of sliding indicator
                      },
                    }}
                  />
                  <Tab
                    label={
                      <Typography
                        variant="h4"
                        component="span"
                        sx={{
                          display: "inline-block",
                          lineHeight: 1,
                          fontWeight: 800,
                        }}
                      >
                        Location
                      </Typography>
                    }
                    sx={{
                      ...tabStyle,
                      fontSize: { xs: "0.6rem", sm: "0.7rem" },
                      "&.Mui-selected": {
                        borderBottom: "3px solid black", // solid underline instead of sliding indicator
                      },
                    }}
                  />
                </Tabs>
              </Box>
            </Box>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                paddingTop: 2,
              }}
            >
              <InnerContentBox title="" sx={{ width: "90%", padding: 2 }}>
                {activeTab === 0 && (
                  <>
                    <Grid container spacing={15}>
                      <Grid item xs={12} md={8}>
                        {description.map((item, index) => (
                          <AccordionWrapper
                            key={index}
                            question={formatCamelCase(item.question)}
                            answer={item.answer!}
                            smallVersion={true}
                          />
                        ))}
                      </Grid>
                    </Grid>
                  </>
                )}
                {activeTab === 1 && (
                  <Grid container spacing={15} sx={{ paddingLeft: 2 }}>
                    <Grid item xs={12} md={4}>
                      <Box display="flex" justifyContent="center">
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                        >
                          {home?.houseType === "apartment" ? (
                            <ApartmentIcon
                              style={{
                                fontSize: 100,
                                color: "black",
                              }}
                            />
                          ) : (
                            <HomeIcon
                              style={{
                                fontSize: 100,
                                color: "black",
                              }}
                            />
                          )}
                          <Typography variant="caption" component="p">
                            {home?.houseType === "apartment"
                              ? "Apartment"
                              : "House"}
                          </Typography>
                        </Box>
                      </Box>

                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        pt={2}
                      >
                        <TextField
                          label="Surface area"
                          sx={{
                            backgroundColor: theme.palette.primary.main,
                            width: "80%",
                          }}
                          disabled={true}
                          value={
                            (home?.surfaceArea?.number || 0) +
                            " " +
                            (home?.surfaceArea?.unit || "m2")
                          }
                        />
                        <Box width={20} />
                      </Box>
                      <Box height={20} />
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          pl: 2,
                        }}
                      >
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <Typography
                              variant="h6"
                              sx={{
                                fontWeight: 400,
                                textAlign: "left",
                              }}
                            >
                              Bedrooms:
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="h6"
                              sx={{
                                fontWeight: 400,
                                textAlign: "center",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                minWidth: 0,
                              }}
                            >
                              {home?.extras?.bedrooms || 0}
                            </Typography>
                          </Grid>

                          <Grid item xs={6}>
                            <Typography
                              variant="h6"
                              sx={{
                                fontWeight: 400,
                                textAlign: "left",
                              }}
                            >
                              Bathrooms:
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="h6"
                              sx={{
                                fontWeight: 400,
                                textAlign: "center",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                minWidth: 0,
                              }}
                            >
                              {home?.extras?.bathrooms || 0}
                            </Typography>
                          </Grid>

                          <Grid item xs={6}>
                            <Typography
                              variant="h6"
                              sx={{
                                fontWeight: 400,
                                textAlign: "left",
                              }}
                            >
                              Kitchens:
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="h6"
                              sx={{
                                fontWeight: 400,
                                textAlign: "center",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                minWidth: 0,
                              }}
                            >
                              {home?.extras?.kitchens || 0}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>
                  </Grid>
                )}

                {activeTab === 2 && (
                  <Grid container spacing={15} sx={{ paddingLeft: 2 }}>
                    <Grid item xs={12} md={6}>
                      <AvailabilitySelector
                        availabilityData={home?.availability}
                        setAvailabilityData={(data) => {}}
                      />
                    </Grid>
                  </Grid>
                )}
                {activeTab === 3 && (
                  <Typography variant="body1">
                    {[home?.address, home?.zipCode].filter(Boolean).join(", ")}
                    <br />
                    {[home?.city, home?.country].filter(Boolean).join(", ")}
                  </Typography>
                )}
              </InnerContentBox>
            </Box>
          </Grid>
          <Grid item xs={12} md={4} alignItems="flex-start">
            <Box sx={{ width: "100%", pt: 14 }}>
              <UserInfo
                user={
                  {
                    _id: home?.ownerId,
                    pictureURL: home?.ownerPictureUrl,
                    firstName: home?.ownerFirstName,
                    lastName: home?.ownerLastName,
                    email: home?.email,
                    phoneNumber: home?.phoneNumber,
                    languages: home?.ownerLanguages,
                    socialMedia: home?.ownerSocialMedia,
                    studentInfo: home?.studentInfo,
                  } as User
                }
                setUpdateData={() => {
                  return;
                }}
                updateData={
                  {
                    pictureURL: home?.ownerPictureUrl,
                    firstName: home?.ownerFirstName,
                    lastName: home?.ownerLastName,
                    email: home?.email,
                    phoneNumber: home?.phoneNumber,
                    languages: home?.ownerLanguages,
                    socialMedia: home?.ownerSocialMedia,
                  } as User
                }
                isDesktop={isDesktop}
                home={home}
              />
            </Box>
          </Grid>
        </Grid>
        <ImagesModal
          files={home?.files!}
          open={open}
          currentImageIndex={currentImageIndex}
          onClose={handleClose}
          onPrev={handlePrev}
          onNext={handleNext}
        />
      </ThemeProvider>
      <Footer />
    </Box>
  );
}

interface SendRequestButtonProps {
  home: HomeWithUserData;
}

export const SendRequestButton = ({ home }: SendRequestButtonProps) => {
  const [openSignUpModal, setSignUpModal] = useState(false);
  const isSignedIn = getIsSignedIn();

  const [requestContact, { isLoading: isRequesting }] =
    useRequestContactMutation();
  const [acceptContact, { isLoading: isAccepting }] =
    useAcceptContactMutation();
  const { enqueueSnackbar } = useSnackbar();
  return (
    <>
      {!home?.isAllowed && (
        <Box
          sx={{
            width: "100%",
            pt: 5,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <MainButton
            text={
              home?.isReQuested
                ? "Accept contact request"
                : "Send contact request"
            }
            disabled={home?.reQuestSent}
            isLoading={home?.isReQuested ? isAccepting : isRequesting}
            onClick={async () => {
              if (!isSignedIn) {
                setSignUpModal(true);
              } else {
                try {
                  if (home?.isReQuested) {
                    await acceptContact(home._id?.toString()!).unwrap();
                    enqueueSnackbar("Contact request accepted!", {
                      variant: "success",
                    });
                  } else {
                    if (home?.ownerId) {
                      await requestContact(home._id?.toString()!).unwrap();
                      trackPostHogEvent("contact_requested", {
                        source: "user_home",
                      });
                      enqueueSnackbar("Contact request sent!", {
                        variant: "success",
                      });
                    }
                  }
                } catch (e) {
                  enqueueSnackbar("Something went wrong. Please try again.", {
                    variant: "error",
                  });
                }
              }
            }}
          />
          <SignupModal
            additionalText={true}
            open={openSignUpModal}
            onClose={() => setSignUpModal(false)}
          />
        </Box>
      )}
    </>
  );
};

const renderImageOrPlaceholder = (
  imageUrl: string | undefined,
  index: number,
  handleOpen: (index: number) => void,
) => {
  return imageUrl ? (
    <img
      src={imageUrl}
      alt={`Image ${index}`}
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
      }}
      onClick={() => handleOpen(index)}
    />
  ) : (
    <div style={{ width: "100%", height: "100%" }}></div>
  );
};
